var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_858_3134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.23486 19.0703C7.70435 20.1317 8.76684 20.8745 10.0001 20.8745C11.2334 20.8745 12.2959 20.1317 12.7654 19.0703H7.23486Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99982 2.78581C10.8137 2.78581 11.5951 2.9294 12.3203 3.1923V3.10297C12.3203 1.87446 11.3208 0.875 10.0924 0.875H9.90772C8.67921 0.875 7.67975 1.87446 7.67975 3.10297V3.19116C8.40454 2.92905 9.18575 2.78581 9.99982 2.78581Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3233 17.8963H2.6766C2.3995 17.8963 2.14568 17.7095 2.08805 17.4384C2.031 17.17 2.15331 16.9051 2.40146 16.7905C2.46034 16.7523 2.90357 16.4424 3.34731 15.5047C4.16229 13.7827 4.33335 11.357 4.33335 9.62536C4.33335 6.50087 6.87532 3.95898 9.99977 3.95898C13.1168 3.95898 15.6541 6.48862 15.6661 9.60286C15.6664 9.61033 15.6666 9.61784 15.6666 9.62536C15.6666 11.357 15.8376 13.7827 16.6526 15.5047C17.0963 16.4424 17.5395 16.7523 17.5985 16.7905C17.8466 16.9051 17.969 17.17 17.9119 17.4384C17.8542 17.7094 17.6005 17.8963 17.3233 17.8963ZM17.605 16.7946H17.6054H17.605Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clip-path", {
    id: "clip0_858_3134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.875)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellAlt);
export default __webpack_public_path__ + "static/media/bell-alt.f211868627e4c36c071c13919e58d056.svg";
export { ForwardRef as ReactComponent };